import { Button, Text, Select, Group } from "@mantine/core";
import React, { useState } from "react";
import moment from "moment";
import { useServerApi } from "../../hooks/userServerApi";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../../utils/openReport";

const ConsultantReportGIRenewal = () => {
  const [month, setMonth] = useState();
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();
  const { t } = useTranslation();

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.Renewal.getConsultantReport(month);
      setLoading(false);
      if (result?.data?.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const prevMonths = 6;
  const nextMonths = 12;
  const possibleMonths = [];
  for (let i = -prevMonths; i <= nextMonths; i++) {
    const m = moment().add(i, "months").format("YYYY-MM");
    possibleMonths.push({ label: m, value: m });
  }

  return (
    <div>
      <Text size="xs">{t("Please select the period of records")}</Text>
      <Group mt="xs">
        <Select
          size="xs"
          data={possibleMonths}
          placeholder="Select Month"
          onChange={(v) => setMonth(v)}
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
    </div>
  );
};

export default ConsultantReportGIRenewal;
